<template>
	<div class="AppProductLaunch">
		<div class="form-section">
			<div class="rows pt-4">
				<el-row>
					<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
						<div class="label-parent">
							<label>
								Name Of Product
							</label>
						</div>
					</el-col>
					<el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
						<el-select
							v-model="value"
							placeholder="Category"
							class="p-2 pr-4 mr-2"
						>
							<el-option
								v-for="item in 5"
								:key="item.value"
								:label="item"
								:value="item"
							/>
						</el-select>
						<el-select
							v-model="value"
							placeholder="Product Name"
							class="p-2 pr-4 mr-2"
						>
							<el-option
								v-for="item in 5"
								:key="item.value"
								:label="item"
								:value="item"
							/>
						</el-select>
						<el-select v-model="value" placeholder="Size" class="p-2 pr-4 mr-2">
							<el-option
								v-for="item in 5"
								:key="item.value"
								:label="item"
								:value="item"
							/>
						</el-select>
						<el-select
							v-model="value"
							placeholder="Prize"
							class="p-2 pr-4 mr-2"
						>
							<el-option
								v-for="item in 5"
								:key="item.value"
								:label="item"
								:value="item"
							/>
						</el-select>
					</el-col>
				</el-row>
			</div>

			<div class="rows ">
				<el-row>
					<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
						<div class="label-parent">
							<label>
								Launch Location
							</label>
						</div>
					</el-col>
					<el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
						<div class="div-flex">
							<input type="radio" class="m-2 radio-btn" />All
						</div>
					</el-col>
					<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
						<div class="label-parent">
							<label>
								Choose Locations
							</label>
						</div>
					</el-col>
					<el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
						<el-select
							v-model="value"
							placeholder="choose Title/Type"
							class="p-2 pr-4 mr-2"
						>
							<el-option
								v-for="item in 5"
								:key="item.value"
								:label="item"
								:value="item"
							/>
						</el-select>
					</el-col>
				</el-row>
			</div>

			<div class="rows ">
				<el-row>
					<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
						<div class="label-parent">
							<label>
								Launch Period
							</label>
						</div>
					</el-col>
					<el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
						<div class="date-picker">
							Start Date :
							<el-date-picker
								type="datetime"
								placeholder="Select date and time"
								class="p-2"
							/>
						</div>
						<div class="date-picker">
							End Date :
							<el-date-picker
								type="datetime"
								placeholder="Select date and time"
								class="p-2"
							/>
						</div>
					</el-col>
				</el-row>
			</div>

			<div class="rows">
				<el-row>
					<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
						<div class="label-parent">
							<label>
								Reference Product
							</label>
						</div>
					</el-col>
					<el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
						<el-select
							v-model="value"
							placeholder="Categry"
							class="p-2 pr-4 mr-2"
						>
							<el-option
								v-for="item in 5"
								:key="item.value"
								:label="item"
								:value="item"
							/>
						</el-select>
						<el-select
							v-model="value"
							placeholder="Product Name"
							class="p-2 pr-4 mr-2"
						>
							<el-option
								v-for="item in 5"
								:key="item.value"
								:label="item"
								:value="item"
							/>
						</el-select>
						<el-select v-model="value" placeholder="Size" class="p-2 pr-4 mr-2">
							<el-option
								v-for="item in 5"
								:key="item.value"
								:label="item"
								:value="item"
							/>
						</el-select>
						<el-select
							v-model="value"
							placeholder="Price"
							class="p-2 pr-4 mr-2"
						>
							<el-option
								v-for="item in 5"
								:key="item.value"
								:label="item"
								:value="item"
							/>
						</el-select>
					</el-col>
				</el-row>
			</div>

			<div class="rows ">
				<el-row>
					<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
						<div class="label-parent">
							<label>
								Launch Location
							</label>
						</div>
					</el-col>
					<el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
						<div class="div-flex">
							<input type="radio" class="m-2 radio-btn" />All
						</div>
					</el-col>
					<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
						<div class="label-parent">
							<label>
								Choose Locations
							</label>
						</div>
					</el-col>
					<el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
						<el-select
							v-model="value"
							placeholder="choose Title/Type"
							class="p-2 pr-4 mr-2"
						>
							<el-option
								v-for="item in 5"
								:key="item.value"
								:label="item"
								:value="item"
							/>
						</el-select>
					</el-col>
				</el-row>
			</div>

			<div class="rows ">
				<el-row>
					<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
						<div class="label-parent">
							<label>
								Launch Period
							</label>
						</div>
					</el-col>
					<el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
						<div class="date-picker">
							Start Date :
							<el-date-picker
								type="datetime"
								placeholder="Select date and time"
								class="p-2"
							/>
						</div>
						<div class="date-picker">
							End Date :
							<el-date-picker
								type="datetime"
								placeholder="Select date and time"
								class="p-2"
							/>
						</div>
					</el-col>
				</el-row>
			</div>

			<div class="rows">
				<el-row>
					<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
						<div class="label-parent">
							<label>
								Reference Article sales
							</label>
						</div>
					</el-col>
					<el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
						<div class="inner-div">
							<div class="mr-4">
								<input type="text" class="custom-input" />
							</div>
							<div class="mr-4">
								<input type="text" class="custom-input" />
							</div>
							<div class="mr-4">
								<input type="text" class="custom-input" />
							</div>
							<div class="mr-4">
								<input type="text" class="custom-input" />
							</div>
							<div class="mr-4">
								<input type="text" class="custom-input" />
							</div>
						</div>
					</el-col>
				</el-row>
			</div>

			<div class="rows margin-top-bottom">
				<el-row>
					<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
						<div class="label-parent">
							<label>
								Forcast
							</label>
						</div>
					</el-col>
					<el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
						<div class="inner-div">
							<div class="mr-4">
								<input type="text" class="custom-input" />
							</div>
							<div class="mr-4">
								<input type="text" class="custom-input" />
							</div>
							<div class="mr-4">
								<input type="text" class="custom-input" />
							</div>
							<div class="mr-4">
								<input type="text" class="custom-input" />
							</div>
							<div class="mr-4">
								<input type="text" class="custom-input" />
							</div>
						</div>
					</el-col>
				</el-row>
			</div>

			<div class="link-rows">
				<a href="">
					Click for detailed forcast
				</a>
			</div>

			<div class="rows  margin-top-bottom">
				<el-row>
					<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
						<div class="label-parent">
							<label>Approve Forcast</label>
						</div>
					</el-col>
					<el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
						<div class="text-lg checkbox-style align-middle">
							<input type="checkbox" />
							All
						</div>
					</el-col>
					<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
						<div class="label-parent">
							<label>Approve Forcast</label>
						</div>
					</el-col>
					<el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
						<input type="text" class="custom-input" />
					</el-col>
				</el-row>
			</div>

			<div>
				<button class="save-btn">
					Save Forcast
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "AppProductLaunch",
	mixins: [],
	props: [],
	data() {
		return {
			value: "",
			value1: ""
		};
	},
	methods: {}
};
</script>

<style lang="scss" scoped>
@import "./AppProductLaunch.scss";
@import "./AppProductLaunchM.scss";
</style>
<style>
.AppProductLaunch .el-input__inner {
	border: 1px solid #c8c8c8;
	border-radius: 20px;
}
.AppProductLaunch .date-picker .el-input__inner {
	border: 1px solid #c8c8c8;
	border-radius: 4px;
}
.AppProductLaunch .el-checkbox__inner {
	width: 18px;
	height: 18px;
}
.AppProductLaunch .el-checkbox__label {
	padding-left: 10px;
	font-size: 18px;
}
.AppProductLaunch .el-checkbox__inner::after {
	height: 11px;
	left: 6px;
}
.AppProductLaunch .date-picker .el-input__icon {
	padding: 8px 0 0px 13px;
}
.AppProductLaunch .el-input--suffix .el-input__inner {
	padding-right: 20px;
	/* width: 234px; */
}
</style>
